import { useAppSelector } from "@/store"
import {
  INFO_MODAL_TYPES,
  useGetInfoModalHasReadQuery
} from "@/store/apis/infoModalAPI"
import { AppSelectors } from "@/store/slices/app"

const LEGAL_LANG = "en"

export interface IPoliciesAcceptedResult {
  termsAccepted: boolean
  policyAccepted: boolean
  termsLoaded: boolean
  policyLoaded: boolean
  allAccepted: boolean
  isReady: boolean
}

export const usePoliciesAccepted = (): IPoliciesAcceptedResult => {
  const reAuthState = useAppSelector(AppSelectors.selectReAuthState())
  const isReady = reAuthState === "idle"

  const { data: termsHasRead } = useGetInfoModalHasReadQuery(
    { type: INFO_MODAL_TYPES.TERMS, lang: LEGAL_LANG },
    { skip: !isReady }
  )

  const termsAccepted = termsHasRead?.hasRead === true
  const termsLoaded = termsHasRead !== undefined

  const { data: policyHasRead } = useGetInfoModalHasReadQuery(
    { type: INFO_MODAL_TYPES.PRIVACY, lang: LEGAL_LANG },
    { skip: !isReady || !termsAccepted }
  )

  const policyAccepted = policyHasRead?.hasRead === true
  const policyLoaded = policyHasRead !== undefined

  const allAccepted = termsAccepted && policyAccepted

  return {
    termsAccepted,
    policyAccepted,
    termsLoaded,
    policyLoaded,
    allAccepted,
    isReady
  }
}
